import { useEffect, useRef, useState } from "react";

export default function MovingCircle() {
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [velocity, setVelocity] = useState({ x: 3, y: 2 });
  const [size, setSize] = useState(50);
  const [angle, setAngle] = useState(0);

  const requestRef = useRef();

  useEffect(() => {
    const update = () => {
      setPosition(prev => {
        let newX = prev.x + velocity.x;
        let newY = prev.y + velocity.y;
        let newVel = { ...velocity };

        const maxX = window.innerWidth - size;
        const maxY = window.innerHeight - size;

        if (newX <= 0 || newX >= maxX) newVel.x *= -1;
        if (newY <= 0 || newY >= maxY) newVel.y *= -1;

        setVelocity(newVel);
        return {
          x: Math.max(0, Math.min(newX, maxX)),
          y: Math.max(0, Math.min(newY, maxY))
        };
      });

      setAngle(prev => prev + 5);

      // Randomly change size every 100 frames or so
      // if (Math.random() < 0.02) {
      //   setSize(30 + Math.random() * 70); // between 30 and 100px
      // }

      requestRef.current = requestAnimationFrame(update);
    };

    requestRef.current = requestAnimationFrame(update);
    return () => cancelAnimationFrame(requestRef.current);
  }, [velocity, size]);

  return (
    <div
      style={{
        position: "absolute",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "red",
        top: position.y,
        left: position.x,
        transform: `rotate(${angle}deg)`,
        transition: "width 0.2s, height 0.2s",
      }}
    />
  );
}
